import * as React from 'react';
export const kakaopaySvg = React.forwardRef(function kakaopaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M1 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1Zm2 7.85C3 5.723 5.24 4 8 4v.002c2.762 0 5 1.724 5 3.85 0 2.125-2.24 3.849-5 3.849-.305 0-.606-.025-.9-.065L5.074 12.97a.145.145 0 0 1-.19-.009.14.14 0 0 1-.036-.147L5.32 11.1C3.928 10.415 3 9.215 3 7.849Z',
      clipRule: 'evenodd',
    }),
  );
});
kakaopaySvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var kakaopay = {
  category: 'paymentmethod',
  colorable: true,
  name: 'kakaopay',
  svg: kakaopaySvg,
};
